// Central, editable content for Elite Development Consulting USA.
// Update copy, services, sectors and contact details here.

export const BRAND = {
  name: "Elite Development Consultants",
  nameSuffix: "USA LLC",
  positioning: "Development Advisory · Owner's Representation · Project Controls",
  tagline: ["Protecting Owners.", "Maximizing Value.", "Delivering Successful Projects."],
  intro:
    "A nationwide development advisory firm built to sit on one side of the table — yours. We guide owners, investors and developers through feasibility, capital, risk and delivery, from the first pro forma to final closeout.",
  phone: "310-704-6505",
  phoneHref: "tel:+13107046505",
  email: "david@elitedevelopmentconsultantsusa.com",
  emailHref: "mailto:david@elitedevelopmentconsultantsusa.com",
  address: ["9465 Wilshire Boulevard, Suite 300", "Beverly Hills, CA 90212"],
  serviceArea: "Serving residential & commercial clients nationwide",
  experienceYears: "22",
};

export const MANIFESTO = [
  {
    no: "01",
    title: "We answer only to the owner.",
    body: "We stay on the advisory side of the table — never the licensed general contractor. That independence means every recommendation protects your capital, your schedule and your position, with no competing incentive.",
  },
  {
    no: "02",
    title: "Capital deserves clarity.",
    body: "Feasibility studies, pro formas and financial models that hold up to lender and investor scrutiny. We translate a development vision into defensible numbers before a dollar is committed.",
  },
  {
    no: "03",
    title: "Risk is managed, not discovered.",
    body: "Due diligence, budget controls and proactive risk assessment surface problems while they are still cheap to solve — long before they reach the field.",
  },
];

export const SERVICES = [
  { no: "01", title: "Development Feasibility", desc: "Rigorous studies that test whether a project pencils — market, cost, schedule and return, assessed before commitment." },
  { no: "02", title: "Owner's Representation", desc: "Your executive presence on the project. We manage the team, protect intent and keep delivery aligned to your goals." },
  { no: "03", title: "Pro Formas & Financial Modeling", desc: "Investor- and lender-grade models that turn a development vision into defensible, decision-ready numbers." },
  { no: "04", title: "Construction Consulting", desc: "Deep construction expertise applied to constructability, means, methods and value — without holding the contract." },
  { no: "05", title: "Risk Management", desc: "Structured risk assessment across entitlement, design, cost and delivery, with mitigation built into the plan." },
  { no: "06", title: "Budgeting & Cost Control", desc: "Hard budgets, change management and cost tracking that keep capital disciplined from pre-development to closeout." },
  { no: "07", title: "Contractor Selection", desc: "Procurement strategy, qualification and bid analysis to select the right builder on the right terms." },
  { no: "08", title: "Schedule Planning", desc: "Critical-path planning and milestone control that keep the project honest against time and money." },
  { no: "09", title: "Due Diligence", desc: "Site, title, entitlement and physical due diligence that answers hard questions before you close." },
  { no: "10", title: "Investor & Lender Reporting", desc: "Clear, credible reporting that keeps your capital partners informed, confident and aligned." },
];

export const SECTORS = {
  residential: {
    label: "Residential",
    image: "https://images.pexels.com/photos/9150612/pexels-photo-9150612.jpeg",
    items: [
      "Luxury custom homes",
      "Estate developments",
      "Major renovations",
      "Spec homes",
      "Small subdivisions",
      "Multifamily — apartments, condos, townhomes",
    ],
  },
  commercial: {
    label: "Commercial",
    image: "https://images.pexels.com/photos/14589851/pexels-photo-14589851.jpeg",
    items: [
      "Hotels & resorts",
      "Mixed-use developments",
      "Office buildings",
      "Retail centers",
      "Restaurants",
      "Industrial buildings",
      "Self-storage",
      "Affordable housing",
      "Senior living",
      "Land development & master-planned communities",
    ],
  },
};

export const PROCESS = [
  { no: "01", title: "Discovery", desc: "We learn your goals, constraints and vision — and define what a successful outcome looks like." },
  { no: "02", title: "Feasibility", desc: "We pressure-test the opportunity across market, site, entitlement and physical conditions." },
  { no: "03", title: "Financial Modeling", desc: "We build pro formas and models that satisfy lenders, investors and your own risk tolerance." },
  { no: "04", title: "Team Selection", desc: "We qualify, bid and negotiate to secure the right contractor and consultant team." },
  { no: "05", title: "Project Oversight", desc: "We run project controls — cost, schedule and risk — as your representative in the field." },
  { no: "06", title: "Closeout", desc: "We drive completion, punch, documentation and final investor & lender reporting." },
];

export const EXPERIENCE = {
  facts: [
    { value: "22+", label: "Years of combined construction & development experience" },
    { value: "3", label: "Project types — residential, commercial & mixed-use" },
    { value: "10+", label: "Development sectors served" },
    { value: "100%", label: "Owner-side — aligned only to your interests" },
  ],
  body:
    "Our experience spans hands-on construction and complex development — from luxury custom homes and estate renovations to multifamily, hospitality, mixed-use and land development. We bring that field-tested judgment to the owner's side of the table, on projects of widely varying scale and capital structure.",
  sectorsTitle: "Sectors we've worked in",
};

export const ROLE_STATEMENT =
  "Elite Development Consultants USA provides owner-side development advisory and consulting services. We do not act as the licensed general contractor unless separately engaged and authorized to do so. Our role is to protect the owner's interests — independent of any construction contract.";

export const CTA_OPTIONS = [
  {
    title: "Book a Strategy Session",
    desc: "A focused working session to pressure-test your development vision, priorities and next moves.",
  },
  {
    title: "Schedule a Development Review",
    desc: "A structured review of feasibility, budget, schedule and risk on an active or planned project.",
  },
  {
    title: "Request a Project Assessment",
    desc: "An independent assessment of where your project stands — and where value or risk is hiding.",
  },
];

export const STATS = [
  { value: "22", label: "Years of Experience" },
  { value: "2", label: "Sectors — Residential & Commercial" },
  { value: "50", label: "States Served, Nationwide" },
  { value: "100%", label: "Owner-Aligned, Always" },
];

export const MARQUEE = [
  "Protecting Owners",
  "Maximizing Value",
  "Delivering Successful Projects",
  "Development Advisory",
  "Owner's Representation",
  "Project Controls",
];

export const PROJECT_TYPES = [
  "Luxury Custom Home",
  "Estate / Major Renovation",
  "Multifamily",
  "Hotel / Resort",
  "Mixed-Use",
  "Office / Retail",
  "Industrial / Self-Storage",
  "Senior Living / Affordable Housing",
  "Land / Master-Planned Community",
  "Other",
];
